import React,{Component} from 'react'
import DatePicker from "react-datepicker";
import './InputDatepicker.css'
import classnames from 'classnames';
import moment from "moment";
import { getTranslate } from 'react-localize-redux';
import {connect} from 'react-redux';
import FaCalendar from "react-icons/lib/fa/calendar";
class InputDatepicker extends Component {
    constructor(){
        super()
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
    }
    
    handleChange(date){
        this.props.input.onChange(date);
    }
    render(){
        const {disabled,options,labelName,translate,id,placeholder,input,maxDate,minDate, meta: { touched, error, warning }}= this.props;
        return(
            <div className="input-datePicker" style={{zIndex:id}}>
                <label className={classnames('datePicker-label',{'datePicker-has-value-label':input.value})}  htmlFor={labelName} > <FaCalendar/> {translate(labelName)}</label>
                <DatePicker
                    id={labelName}
                    onBlur={() => input.onBlur()}
                    onFocus={() => input.onFocus()}
                    selected={input.value ? input.value : null}
                    onChange={this.handleChange}
                    dateFormat="DD/MM/YYYY"
                    canClearSelection={false}
                    minDate={moment(minDate)}
                    maxDate={moment(maxDate)}
                    placeholderText={''}
                    readOnly={true}
                    disabled={disabled}
                    className={classnames({'error-datePicker':error && touched},{'hasValue':input.value})}
                />
                {touched && (error && <span className="error-text">{translate(error)} *</span>)}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
});

export default connect(mapStateToProps)(InputDatepicker)


// WEBPACK FOOTER //
// ./src/components/Input-datepicker/InputDatepicker.js